import  Vue  from  "vue";
import moment from 'moment';

Vue.filter("formatDate",  function(date)  {
    
    if  (!date)
        return  "";
    return moment(date).format('MM/DD/YYYY HH:MM')
});